import { createWebHashHistory, createRouter } from "vue-router";
import routes from "./routes";

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (to.path == "/user/auth") {
    next();
    return;
  }

  if (to.path.includes("/site/test") || to.path.includes("/site/tg-test")) {
    next();
    return;
  }

  if (to.path !== "/auth/sign-in" && from.path !== "/auth/sign-in" && !token) {
    next("/auth/sign-in");
    return;
  }

  if (to.path === "/" && from.path === "/" && !token) {
    next("/auth/sign-in");
    return;
  }

  if (to.path === "/" && from.path === "/" && token) {
    switch (role) {
      case "ADMIN":
        next("/cabinet/admin/users");
        break;
      case "CLIENT":
        next("/user/profile");
        break;
    }
    return;
  }

  next();
});

export default router;
